import vFileUploader from './FileUploader';

export { vFileUploader };



// WEBPACK FOOTER //
// ./src/baseComponents/components/FileUploader/index.js